import React from 'react';
import { motion } from 'framer-motion';
import { SITE } from '@/constants/testIds';

export const Contact = ({ onBook }) => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <section
      id="contact"
      data-testid={SITE.contact}
      className="section-light py-24 md:py-32 px-5 md:px-10"
    >
      <div className="container-narrow">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-3">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-10% 0px' }}
              transition={{ duration: 0.7, ease }}
              className="flex items-center gap-3"
            >
              <span className="index-chip text-[color:var(--gold-3)]">
                09
              </span>
              <span className="eyebrow eyebrow-light">Contact</span>
            </motion.div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-10% 0px' }}
              transition={{ duration: 0.85, ease }}
              className="font-serif text-[40px] sm:text-[56px] md:text-[72px] leading-[1.02] tracking-[-0.02em] text-[color:var(--charcoal)]"
            >
              Start a conversation with a
              <span className="italic text-[color:var(--gold-3)]"> partner</span>
              , not a form.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-10% 0px' }}
              transition={{ duration: 0.7, delay: 0.15, ease }}
              className="mt-8 text-[16px] md:text-[17px] leading-[1.65] text-[color:var(--charcoal-2)] max-w-[640px]"
            >
              For M&amp;A mandates, capital raises and strategic project
              advisory across India, the MENA region and Hong Kong — reach the
              partner directly, or share the outline of a situation and we&apos;ll
              come back to you within one business day.
            </motion.p>
          </div>
        </div>

        <div className="mt-14 h-px bg-[color:var(--rule-light)]" />

        <div className="mt-14 grid grid-cols-12 gap-6 md:gap-12">
          <div className="col-span-12 md:col-span-7">
            <p className="small-caps text-[11px] text-[color:var(--gold-3)]">
              Direct channels
            </p>
            <div className="mt-6 space-y-6">
              <div>
                <p className="small-caps text-[10.5px] text-[color:var(--charcoal-3)]">
                  Email
                </p>
                <a
                  data-testid={SITE.contactEmail}
                  href="mailto:mk@no-bs.in"
                  className="mt-2 block font-serif text-[24px] md:text-[28px] text-[color:var(--charcoal)] hover:text-[color:var(--gold-3)] transition-colors"
                >
                  mk@no-bs.in
                </a>
              </div>
              <div>
                <p className="small-caps text-[10.5px] text-[color:var(--charcoal-3)]">
                  Phone
                </p>
                <a
                  data-testid={SITE.contactPhone}
                  href="tel:+919324805849"
                  className="mt-2 block font-serif text-[24px] md:text-[28px] text-[color:var(--charcoal)] hover:text-[color:var(--gold-3)] transition-colors"
                >
                  +91 93248-05849
                </a>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <button onClick={onBook} className="btn-primary-light">
                Start a Conversation
                <span aria-hidden>→</span>
              </button>
              <a href="mailto:mk@no-bs.in" className="btn-ghost-light">
                Email partner directly
              </a>
            </div>
          </div>

          <div className="col-span-12 md:col-span-5">
            <p className="small-caps text-[11px] text-[color:var(--gold-3)]">
              Studio
            </p>
            <address
              data-testid={SITE.contactAddress}
              className="mt-6 not-italic font-serif text-[20px] md:text-[22px] leading-[1.45] text-[color:var(--charcoal)]"
            >
              Ground Floor, Winchester
              <br />
              Hiranandani Gardens, Powai
              <br />
              Mumbai — 400076
              <br />
              Maharashtra, India
            </address>

            <div className="mt-10 grid grid-cols-2 gap-6">
              <MetaCell label="Regions" value="India · MENA · Hong Kong" />
              <MetaCell label="Hours" value="Mon – Fri · 09—19 IST" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const MetaCell = ({ label, value }) => (
  <div>
    <p className="small-caps text-[10.5px] text-[color:var(--charcoal-3)]">
      {label}
    </p>
    <p className="mt-2 text-[14px] text-[color:var(--charcoal)]">{value}</p>
  </div>
);

export default Contact;
